import React from 'react'

export default function FundraisingSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_27932_18119)">
        <path
          d="M8.66658 15.6978L14.1634 9.38835C16.5429 6.82476 16.438 3.60515 14.8336 1.65046C14.0354 0.677111 12.8727 0.036213 11.527 0.00154578C10.3777 -0.0286769 9.16968 0.383773 8.00437 1.28334C6.83551 0.383773 5.62398 -0.0286769 4.47289 0.00154578C3.12625 0.0371019 1.96183 0.677111 1.16273 1.65046C-0.442566 3.60693 -0.539453 6.82653 1.84894 9.38924L7.34483 15.6978C7.51372 15.8898 7.75371 16 8.00526 16C8.13056 15.9998 8.25436 15.9727 8.36829 15.9206C8.48223 15.8685 8.58365 15.7925 8.66569 15.6978H8.66658Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_27932_18119">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}
